<template>
  <div class="cp-rule">
    <div class="close" @click="handleClose"></div>
    <div class="rule">
    </div>
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .cp-rule
    width 100%
    height 100%
    display flex
    flex-direction column
    justify-content center
    align-items center
    .close
      width 0.47rem
      height 0.47rem
      background-image url('./images/close.png')
      background-size 100% 100%
      margin-bottom 0.12rem
      cursor: pointer
      transition transform 0.6s ease-in-out
      &:hover
        transform: rotateZ(360deg);
    .rule
      width 5.18rem
      height 5.57rem
      background-image url('./images/rule.png')
      background-size 100% 100%
</style>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';

export default {
  name: 'Share',
  beforeMount() {

  },
  mounted() {

  },
  methods: {
    handleClose(e) {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

